import React from 'react'

export default function CheckoutHeader() {
    return (
        <tr>
            <th className="">Item</th>
            <th>Description</th>
            <th className="">Price</th>
            <th>Quantity</th>
            <th>Remove</th>
        </tr>
    )
}
